import Button from "@Components/Button";
import Card from "@Components/Card";
import InfoPopup from "@Components/InfoPopup";
import React from "react";
import styles from "./index.module.scss";
export default class InformUnchange extends React.Component {
    constructor(props) {
        super(props);
    }
    unsavePopup = (close) => {
        return (React.createElement(Card, { className: styles.unsavePopup },
            React.createElement("h3", { className: styles.title }, "You have unsaved changes. Are you sure you want to leave without saving?"),
            React.createElement("div", { className: styles.actions },
                React.createElement(Button, { click: close, className: styles.cancelBtn, dark: true }, "CANCEL"),
                React.createElement(Button, { click: this.props.onConfirm }, "LEAVE WITHOUT SAVING"))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.unsavePopup, onClose: this.props.close }));
    }
}
